<template>
  <div
    class="col-xs-6 up-container"
    :style="{ 'padding-right': paddingRight }"
  >
    <div class="up">
      <img
        :src="img"
        :alt="imgAlt"
      >
      <template v-if="update.complete">
        <div
          class="up-date"
        >
          {{ update.date | moment('DD.MM.YYYY') }}
        </div>
        <div
          class="up-time"
        >
          {{ update.date | moment('HH:mm') }}
        </div>
      </template>
      <div
        v-else
        class="up-time"
      >
        Идет расчет
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Информация по "апдейту".
 */
export default {
  name: 'UpInfo',
  props: {
    /**
     * Данные апдейта.
     */
    update: {
      type: Object,
      required: true
    },
    /**
     * Контент картинки.
     */
    img: {
      type: String,
      required: true
    },
    /**
     * alt-аттрибут для картинки.
     */
    imgAlt: {
      type: String,
      default: 'image'
    },
    /**
     * padding слева.
     */
    paddingLeft: {
      type: String,
      default: '15px'
    },
    /**
     * padding справа.
     */
    paddingRight: {
      type: String,
      default: '15px'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.up-container {
  .up {
    padding: 15px;
    border-radius: $borderRadiusMedium;
    background-color: $contentBackgroundColor;
    height: 100%;

    img {
      margin-bottom: 10px;
    }

    .up-date {
      font-weight: bold;
      font-size: 1.5em;

      @media (max-width: $xsBreakpoint) {
        font-size: 1.3em;
      }
    }

    .up-time {
      font-weight: bold;
      font-size: 1.1em;
    }
  }
}
</style>
